/*/
	Browser Support Snippet
	Stephen Ginn at Crema Design Studio
	Last Updated on 2019-11-07
/*/

var browsers = {
	msie: 99999,
	trident: 11,
	edge: 39,
	chrome: 55,
	firefox: 51,
	safari: 10
},
uAgent = {
	"ua": window.navigator.userAgent.toLowerCase(),
	"browser": {
		name: "Unknown",
		version: 0,
		supported: true
	}
};

for (var browser in browsers) {
	var splitKey = browser + '/';

	uAgent.browser.name = browser;

	if (uAgent.ua.indexOf(splitKey) > -1) {
		var supportedVersion = browsers[browser];

		// Find Version Numbers...
		switch(browser) {
			case "msie":
				splitKey = 'msie ';
				uAgent.browser.name = "ie";
				break;
			case "trident":
				splitKey = 'rv:';
				uAgent.browser.name = "ie";
				break;
			case "safari":
				splitKey = 'version/';
				break;
		}

		uAgent.browser.version = Number(uAgent.ua.split(splitKey)[1].split('.')[0]);

		// Convert EdgeHTML Version to Edge Version...
		if (browser === 'edge') {
			var getEdgeVersion = {
				12: 0.1,
				13: 21,
				14: 31,
				15: 39,
				16: 41,
				17: 42,
				18: 44
			};

			uAgent.browser.version = getEdgeVersion[uAgent.browser.version];
		}

		if (uAgent.browser.version < supportedVersion) {
			uAgent.browser.supported = false;
		}

		break; // exit loop statement
	}
}

document.documentElement.classList.add(uAgent.browser.name + "-" + uAgent.browser.version);

// Feature Detection
// IE11 Support Polyfills

var html = document.documentElement;
html.classList.remove("no-js");
html.classList.add("js");

function insertScript(src) {
	var script = document.createElement('script');
	script.setAttribute("src", src);
	document.head.appendChild(script);
}

var supports = {
	es5: function() {
		"use strict";
		return Function.prototype.bind && !this;
	}(),
	es6: function() {
		if (NodeList.prototype.forEach) {
			return true;
		} else {
			return false;
		}
	}(),
	es7: function() {
		if (Array.prototype.includes) {
			return true;
		} else {
			return false;
		}
	}(),
	es8: function() {
		if (Object.entries) {
			return true;
		} else {
			return false;
		}
	}(),
	es9: function() {
		try {
			Promise.prototype.finally;

			return true;
		} catch(error) {
			return false
		}
	}(),
	es10: function() {
		if (Array.prototype.flat) {
			return true;
		} else {
			return false;
		}
	}()
};



/*/
	ECMAScript Versions
	https://en.wikipedia.org/wiki/ECMAScript
	• es2015 = es6
	• es2016 = es7
	• es2017 = es8
	• es2018 = es9
	• es2019 = es10
/*/

var features = {
	es5: [
		'Array.prototype.forEach',
		'Object.keys'
	],
	es6: [
		'Object.assign',
		'NodeList.prototype.forEach',
		'Array.prototype.@@iterator',
		'WeakSet',
		'Symbol'
	],
	es7: [
		'Array.prototype.includes'
	],
	es8: [
		'Object.entries',
		'Object.values',
	],
	es9: [

	],
	es10: [
		'flat',
		'flatMap'
	],
	current: [
		'default'
	]
}

console.groupCollapsed("Feature Compatibility Tests");

console.log(uAgent);

if (! window.fetch) {
	console.log("Adding Fetch");
	features.current.push('fetch');
}

var versions = ["es5", "es6", "es7", "es8", "es9", "es10"];

for (var i = 0; i < versions.length; ++i) {
	var version = versions[i];

	console.log("Supports " + version.toUpperCase() + "? " + supports[version])

	if (! supports[version]) {
		console.log("Adding " + version.toUpperCase() + " Features");
		features.current = features.current.concat(features[version]);
	}
}

if (! supports.es10) {
	console.log("Adding More ES10 Features");

	Array.prototype.flat = function() {
		return [].concat.apply([], this);
	};

	Array.prototype.flatMap = function(callback) {
		return Array.prototype.map.apply(this, arguments).flat();
	};
}

console.groupEnd();

// Insert Polyfills if Needed:
if (features.current.length > 1) {
	console.error("Your browser sucks. Downloading Polyfills...");

	console.log(features.current);

	var featuresAttr = encodeURIComponent(features.current.join(','));
	insertScript('https://polyfill.io/v3/polyfill.min.js?flags=gated&features=' + featuresAttr);

	NodeList.prototype.forEach = Array.prototype.forEach;
}
